export const c8e1afd3102260cebebfd515adb7 = () => {
    console.log('%c ASAP ', 'background: #FFF; color: #DB2C24; font-size: 30px; border-radius:48px');
}

